/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { APP_INITIALIZER, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { LoginComponent } from './components/login/login.component'
import { ThreedComponent } from './components/threed/threed.component'
import { HomeComponent } from './components/home/home.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FormlyModule } from '@ngx-formly/core'
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap'
import { NavComponent } from './components/nav/nav.component'
import { MenuComponent } from './components/nav/menu.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FeatureHintInputComponent } from './components/feature-hint-input/feature-hint-input.component'
import { Router } from '@angular/router'
import { AuthInterceptor } from './interceptors/auth.interceptor'
import { DataStatusComponent } from './components/data-status/data-status.component'
import { AuthDirective } from './services/auth/auth.directive'
import { AuthService } from './services/auth/auth.service'
import { InitService } from './services/init.service'
import { ProfileComponent } from './components/profile/profile.component'
import { DatamanagerComponent } from './components/datamanager/datamanager.component'
import { ClikclientconfigurationComponent } from './components/datamanager/clikclientconfiguration.component'
import { BusydialogComponent } from './components/modals/busydialog/busydialog.component'
import { MatTableModule } from '@angular/material/table'
import { BatchProcessComponent } from './components/batch-process/batch-process.component'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatInputModule } from '@angular/material/input'
import { ScrollingModule } from '@angular/cdk/scrolling'

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        ThreedComponent,
        HomeComponent,
        NavComponent,
        MenuComponent,
        FeatureHintInputComponent,
        DataStatusComponent,
        AuthDirective,
        ProfileComponent,
        DatamanagerComponent,
        ClikclientconfigurationComponent,
        BusydialogComponent,
        BatchProcessComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormlyModule.forRoot({ extras: { lazyRender: true } }),
        FormlyBootstrapModule,
        NgbModule,
        FormsModule,
        MatProgressSpinnerModule,
        BrowserAnimationsModule,
        MatTableModule,
        MatCheckboxModule,
        MatInputModule,
        ScrollingModule,
    ],
    entryComponents: [BusydialogComponent],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: function (authService: AuthService, router: Router) {
                return new AuthInterceptor(authService, router)
            },
            multi: true,
            deps: [AuthService, Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (initService: InitService) => () => initService.recoverSession(),
            multi: true,
            deps: [InitService],
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
